import { createFeatureSelector } from '@ngrx/store';

import { QuickOrderState } from './quick-order/quick-order.reducer';

export interface CustomQuickorderState {
  quickOrder: QuickOrderState;
}

export const getCustomQuickorderState = createFeatureSelector<CustomQuickorderState>('customQuickorder');
